/**
 * 인증 가드 — 미로그인 시 /login 으로 리다이렉트.
 *
 *   <ProtectedRoute><Dashboard /></ProtectedRoute>
 *
 * 로그인 후 원래 가려던 곳으로 돌아오게 location.state.from 보존.
 */

import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../lib/auth-context';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="flex h-screen items-center justify-center text-slate-500">
        로딩 중…
      </div>
    );
  }

  if (status === 'guest') {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
